"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = NavbarStartSection;
var _react = _interopRequireDefault(require("react"));
var _react2 = require("@linaria/react");
var _core = require("@linaria/core");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
var _icon = require("@site/pattern-library-utils/icon");
var _animation = require("../../../animation");
// ============================================================================
// BASE STYLED COMPONENTS
// ============================================================================

const LeadingSectionBase = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "LeadingSectionBase",
  class: "pl-l1djlizz"
});

// ============================================================================
// BREADCRUMB VARIANT STYLES
// ============================================================================

const LeadingSectionWithBreadcrumb = /*#__PURE__*/(0, _react2.styled)(LeadingSectionBase)({
  name: "LeadingSectionWithBreadcrumb",
  class: "pl-l10lp20k"
});

// ============================================================================
// SIMPLE VARIANT STYLES
// ============================================================================

const LeadingSectionSimple = /*#__PURE__*/(0, _react2.styled)(LeadingSectionBase)({
  name: "LeadingSectionSimple",
  class: "pl-l10lpfn5"
});

// ============================================================================
// TEXT CONTAINER VARIANTS
// ============================================================================

const TextContainerBase = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "TextContainerBase",
  class: "pl-tgb8dph"
});
const TextContainerWithBreadcrumb = /*#__PURE__*/(0, _react2.styled)(TextContainerBase)({
  name: "TextContainerWithBreadcrumb",
  class: "pl-t11ealum"
});
const TextContainerSimple = /*#__PURE__*/(0, _react2.styled)(TextContainerBase)({
  name: "TextContainerSimple",
  class: "pl-t13lcmdn"
});
const BreadcrumbText = /*#__PURE__*/(0, _react2.styled)("a")({
  name: "BreadcrumbText",
  class: "pl-b189rpk7"
});
const MainTitle = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "MainTitle",
  class: "pl-mp3h28d"
});
const TitleText = /*#__PURE__*/(0, _react2.styled)("span")({
  name: "TitleText",
  class: "pl-tg00xu6"
});

// ============================================================================
// CHEVRON VARIANTS
// ============================================================================

const chevronOpenAnimation = "pl-caq4ixh";
const chevronCloseAnimation = "pl-cuqdp1l";
const IconChevronBase = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "IconChevronBase",
  class: "pl-inxiulw"
});
const IconChevronWithBreadcrumb = /*#__PURE__*/(0, _react2.styled)(IconChevronBase)({
  name: "IconChevronWithBreadcrumb",
  class: "pl-i18egk72"
});
const IconChevronSimple = /*#__PURE__*/(0, _react2.styled)(IconChevronBase)({
  name: "IconChevronSimple",
  class: "pl-i120krx8"
});

// ============================================================================
// MAIN COMPONENT
// ============================================================================

/**
 * Navbar Start Section Component
 * Contains breadcrumb text and main navigation title at the start of the navbar
 * @param {Object} props - Component props
 * @returns {React.ReactElement} Navbar Start Section Component
 */
// eslint-disable-next-line complexity
function NavbarStartSection({
  breadcrumbText,
  breadcrumbUrl,
  navTitle,
  expanded,
  onLeadingSectionClick,
  onKeyPress,
  tabIndex,
  partial,
  width
}) {
  const hasBreadcrumb = breadcrumbText && breadcrumbUrl;
  // Choose the appropriate styled components based on breadcrumb presence
  const LeadingSection = hasBreadcrumb ? LeadingSectionWithBreadcrumb : LeadingSectionSimple;
  const TextContainer = hasBreadcrumb ? TextContainerWithBreadcrumb : TextContainerSimple;
  const IconChevronDown = hasBreadcrumb ? IconChevronWithBreadcrumb : IconChevronSimple;
  return /*#__PURE__*/_react.default.createElement(LeadingSection, {
    className: `navbar-start-section ${hasBreadcrumb ? 'navbar-start-section--with-breadcrumb' : 'navbar-start-section--simple'}`,
    "data-cy": "leading-section",
    onClick: onLeadingSectionClick,
    onKeyPress: onKeyPress,
    tabIndex: width > _patternLibraryUtils.size.laptop ? -1 : tabIndex,
    "data-partial": partial
  }, hasBreadcrumb ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(IconChevronDown, {
    "data-cy": "down-chevron",
    className: "title-chevron navbar-start-section__chevron",
    expanded: expanded
  }, /*#__PURE__*/_react.default.createElement(_icon.Icon, {
    name: "chevron-down",
    className: expanded ? chevronOpenAnimation : chevronCloseAnimation
  })), /*#__PURE__*/_react.default.createElement(TextContainer, null, breadcrumbText && breadcrumbUrl && /*#__PURE__*/_react.default.createElement(BreadcrumbText, {
    className: "navbar-start-section__breadcrumb",
    "data-cy": "breadcrumb-text",
    href: breadcrumbUrl,
    onClick: e => e.stopPropagation()
  }, breadcrumbText), /*#__PURE__*/_react.default.createElement(TitleText, {
    className: "navbar-start-section__title",
    "data-cy": "main-title"
  }, navTitle))) :
  /*#__PURE__*/
  /* Desktop or mobile without breadcrumb: original inline layout */
  _react.default.createElement(MainTitle, {
    className: "navbar-start-section__title",
    "data-cy": "main-title"
  }, /*#__PURE__*/_react.default.createElement(IconChevronDown, {
    "data-cy": "down-chevron",
    className: "title-chevron navbar-start-section__chevron",
    expanded: expanded
  }, /*#__PURE__*/_react.default.createElement(_icon.Icon, {
    name: "chevron-down",
    className: expanded ? chevronOpenAnimation : chevronCloseAnimation
  })), /*#__PURE__*/_react.default.createElement(TitleText, null, navTitle)));
}
NavbarStartSection.propTypes = {
  breadcrumbText: _propTypes.default.string,
  breadcrumbUrl: _propTypes.default.string,
  navTitle: _propTypes.default.string.isRequired,
  expanded: _propTypes.default.bool.isRequired,
  onLeadingSectionClick: _propTypes.default.func.isRequired,
  onKeyPress: _propTypes.default.func.isRequired,
  tabIndex: _propTypes.default.number.isRequired,
  partial: _propTypes.default.string,
  width: _propTypes.default.number.isRequired
};